import * as moment from 'moment';
import { tabelaPrecoPromocao } from '../function/promocaoCidade';
import { insereInscricao } from '../../services/inscricao';

export const removeDescontoAdesaoFinados2023 = async (dadosAssociado = {}) => {
    try {
        const dataFinalDaPromocaoDeFinados2023 = moment('2024-03-01').utc();
        const dataDeFinados = moment('2023-10-31').utc();
        const dataAtual = moment().utc();
        const estamosNoPeriodoDeFinados = dataAtual.isBetween(dataDeFinados, dataFinalDaPromocaoDeFinados2023);

        const trocaEntreFormasPermitidasEBoleto = dadosAssociado.AssTipoCobranca === 1 && dadosAssociado.dadosOriginaisAntesDaEdicao.AssTipoCobranca !== 1;

        if (estamosNoPeriodoDeFinados && trocaEntreFormasPermitidasEBoleto){
            const adesao = (await tabelaPrecoPromocao(true, 'cidade', dadosAssociado.codigoIbge, 'Adesao', dadosAssociado.SubGrupo.trim() , 1, 10000))[0];

            if (adesao.descontoCartao !== null || adesao.descontodescontoEscelsa !== null){
                const valorPlanoAdesao = adesao?.adesao_novo;
                const dadosAdesao = {
                    Pagamento: null,
                    tipoPagamento: null,
                    Valor: valorPlanoAdesao,
                    Inscricao: dadosAssociado.inscricao,
                    valorPago: null
                };

                await insereInscricao(dadosAdesao);   
            }
        }
    } catch (error) {
        return error;
    }

    return; 
};